import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'relative',
    minHeight: 300,
    marginBottom: '-5%',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '-20%',
    },
  },
  content: {
    margin: 'auto',
    minHeight: 200,
    maxWidth: 500,
    padding: '0 60px',
  },
  textContainer: {
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 315,
    },
    [theme.breakpoints.down('xs')]: {
      margin: 'unset',
      textAlign: 'left',
    },
  },
  title: {
    ...theme.typography.h2PurpleText,
  },
  text: {
    ...theme.typography.normalGrayText,
  },
}));
